import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { TradingViewStore } from './tradingView.types';

const useTradingViewStoreBase = create<TradingViewStore>()(
  devtools(
    set => ({
      // #region States
      state: {
        tradingViewSubscriptionData: {},
      },

      // #endregion

      // #region Actions
      actions: {
        setTradingViewSubscriptionData: payload => {
          set(
            state => ({
              state: {
                ...state.state,
                tradingViewSubscriptionData: {
                  ...state.state.tradingViewSubscriptionData,
                  [payload.subscribeUID]: payload,
                },
              },
            }),
            false,
            'setTradingViewSubscriptionData'
          );
        },

        updateTradingViewData: data => {
          try {
            set(
              state => {
                const subscription = state.state.tradingViewSubscriptionData[data.sUID];

                if (!subscription) {
                  console.error(
                    'DEBUG :: Error :: No subscription found for sUID',
                    data.sUID
                  );
                  return state;
                }

                // eslint-disable-next-line prefer-destructuring
                const lastBar = subscription?.lastBar;

                if (!lastBar) {
                  return state;
                }

                const newLastBar = {
                  time: data.candle_start_time / 1000,
                  open: data.open || lastBar.close,
                  high: data.high || lastBar.close,
                  low: data.low || lastBar.close,
                  close: data.close || lastBar.close,
                  volume: data?.volume,
                };

                // eslint-disable-next-line no-unused-expressions
                subscription.onRealtimeCallback &&
                  subscription.onRealtimeCallback(newLastBar);

                return {
                  ...state,
                  state: {
                    ...state.state,
                    tradingViewSubscriptionData: {
                      ...state.state.tradingViewSubscriptionData,
                      [data.sUID]: {
                        ...subscription,
                        lastBar: newLastBar,
                      },
                    },
                  },
                };
              },
              false,
              'updateTradingViewData'
            );
          } catch (e) {
            console.error('DEBUG :: Error :: updateTradingViewData', e);
          }
        },
      },

      // #endregion
    }),
    {
      name: 'TradingViewStore',
    }
  )
);

export { useTradingViewStoreBase };
